import dio, { DioContext, DioType } from './init';

export default {
  onHide: () => {
    dio.track('Zowie_onHide', DioType.CLICK, {}, DioContext.CHATBOT);
  },
  onStart: () => {
    dio.track('Zowie_onStart', DioType.CLICK, {}, DioContext.CHATBOT);
  },
  onOpen: () => {
    dio.track('Zowie_onOpen', DioType.CLICK, {}, DioContext.CHATBOT);
  },
  onClose: () => {
    dio.track('Zowie_onClose', DioType.CLICK, {}, DioContext.CHATBOT);
  },
  onEndChat: () => {
    dio.track('Zowie_onEndChat', DioType.CLICK, {}, DioContext.CHATBOT);
  },
};
